export default __webpack_public_path__ + "18fcb3f626f8a4d57fbe2e7c2d2b3a70.svg";